const BASE_KEY = 'AI_SPOTLIGHT';

export const spotlightKeys = {
  all: () => [BASE_KEY] as const,
  count: () => [...spotlightKeys.all(), 'COUNT'] as const,
};
